import { Suspense } from "react";
import { Box, Menu, MenuDivider, MenuList } from "@chakra-ui/react";
import { useState } from "react";

import { useGetUser } from "modules/user/infrastructure/useGetUser";

import { ErrorBoundary } from "components/ErrorBoundary";
import { Spinner } from "components/Spinner";

import { LogoutMenuItem } from "./LogoutMenuItem";
import { ProfileMenuItem } from "./ProfileMenuItem";
import { ActualAppointmentsMenuItem } from "./ActualAppointmentsMenuItem";
import { UserMenuButton } from "./UserMenuButton";
import { HistoricalAppointmentsMenuItem } from "./HistoricalAppointmentsMenuItem";

const ProfileDropdownThrowable = () => {
  const { data: user } = useGetUser();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  if (!user) {
    return <></>;
  }

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    isMenuOpen ? setIsMenuOpen(false) : setIsMenuOpen(true);
  };

  return (
    <Box ml={4}>
      <Menu isOpen={isMenuOpen} id="logged-user-menu-btn">
        <UserMenuButton userName={user.name} toggleMenu={toggleMenu} />
        <MenuList>
          <ProfileMenuItem
            userEmail={user.email}
            userName={user.name}
            closeMenu={closeMenu}
          />
          <ActualAppointmentsMenuItem closeMenu={closeMenu} />
          <HistoricalAppointmentsMenuItem closeMenu={closeMenu} />
          <MenuDivider />
          <LogoutMenuItem closeMenu={closeMenu} />
        </MenuList>
      </Menu>
    </Box>
  );
};

const ProfileDropdown = () => {
  return (
    <ErrorBoundary fallback={() => <></>}>
      <Suspense fallback={<Spinner size="lg" mt={2} mx={4} />}>
        <ProfileDropdownThrowable />
      </Suspense>
    </ErrorBoundary>
  );
};

export { ProfileDropdown };
